<template>
 <div class="aboutUS">
   <!-- 顶部横幅 -->
<!--     <img :src="top" alt="联系我们" style="width: 100%;height: 450px">-->
   <!-- 公司简介 -->

   <div class="background">
     <div class="background-img"><img :src="img_1" style="width:714px;height:340px"></div>
<!--     <div class="background-text">
       <p>联系我们</p>
     </div>-->
   </div>

   <div class="company-intro">
     <div class="container">
       <h2 class="section-title">关于我们</h2>
       <div class="section-divider"></div>
       <p class="intro-text">以"匠心深耕、创新驱动、价值共生"为核心理念，专注为客户提供建筑工业化与工程数字化领域全生命周期解决方案。依托自主研发的智能建造技术体系，整合物联网及人工智能等前沿技术，打造涵盖需求分析、系统设计、开发实施及智慧运维的全流程服务。</p>
     </div>
   </div>

   <!-- 联系信息区域 -->
   <div class="contact-section">
     <div class="container">
       <div class="contact-wrapper">
         <!-- 左侧联系信息 -->
         <div class="contact-info">
           <div class="info-card">
             <h3 class="card-title">联系方式</h3>
             <ul class="info-list">
               <li>
                 <i class="el-icon-location"></i>
                 <div>
                   <h4>公司地址</h4>
                   <p>北京市大兴区龙发大街1号院3号楼6层3单元618</p>
                 </div>
               </li>
               <li>
                 <i class="el-icon-phone"></i>
                 <div>
                   <h4>联系电话</h4>
                   <p>18574931510</p>
                 </div>
               </li>
               <li>
                 <i class="el-icon-message"></i>
                 <div>
                   <h4>电子邮箱</h4>
                   <p>bjztxh001@163.com</p>
                 </div>
               </li>
               <li>
                 <i class="el-icon-time"></i>
                 <div>
                   <h4>工作时间</h4>
                   <p>周一至周五 9:00-18:00</p>
                 </div>
               </li>
             </ul>
           </div>
           
           <!-- 联系表单 -->
           <div class="contact-form-card">
             <h3 class="card-title">在线留言</h3>
             <el-form :model="form" :rules="rules" ref="contactForm" label-position="top">
               <el-form-item prop="name">
                 <el-input v-model="form.name" placeholder="您的姓名" prefix-icon="el-icon-user"></el-input>
               </el-form-item>
               <el-form-item prop="phone">
                 <el-input v-model="form.phone" placeholder="联系电话" prefix-icon="el-icon-phone"></el-input>
               </el-form-item>
               <el-form-item prop="email">
                 <el-input v-model="form.email" placeholder="电子邮箱" prefix-icon="el-icon-message"></el-input>
               </el-form-item>
               <el-form-item prop="message">
                 <el-input type="textarea" v-model="form.message" rows="4" placeholder="请输入您的留言内容"></el-input>
               </el-form-item>
               <el-form-item>
                 <el-button type="primary" @click="submitForm" style="width: 100%">提交留言</el-button>
               </el-form-item>
             </el-form>
           </div>
         </div>
         
         <!-- 右侧地图 -->
         <div class="map-container">
           <div class="map-card">
             <h3 class="card-title">公司位置</h3>
             <div id="container" class="map-content"></div>
           </div>
         </div>
       </div>
     </div>
   </div>
 </div>
</template>

<script>
import AMap from 'AMap' // 引入高德地图
export default {
  data(){
    return {
      top:'',
      img_1:require('../../assets/09.jpg'),
      form: {
        name: '',
        phone: '',
        email: '',
        message: ''
      },
      rules: {
        name: [
          { required: true, message: '请输入您的姓名', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号码', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入电子邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ],
        message: [
          { required: true, message: '请输入留言内容', trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    this.getTop()
    this.initMap()
  },
  methods: {
    // 获取banner
    getTop() {
      let data = {params: {ImgCate: 10}}
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntImgSelect', data).then(res => {
        res = typeof res.data == 'string' ? JSON.parse(res.data) : res.data;
        this.top = res.data[0].ImgPath;
      })
    },
    // 初始化地图
    initMap() {
      // 创建地图实例
      const map = new AMap.Map('container', {
        center: [116.400068, 39.682583],
        zoom: 15,
        resizeEnable: true
      });
      
      // 创建标记
      const marker = new AMap.Marker({
        position: [116.400068, 39.682583],
        title: '北京智砼兴华智能科技有限公司',
        map: map
      });
      
      // 添加信息窗体
      const infoWindow = new AMap.InfoWindow({
        content: `<div class="info-window">
                    <h4>北京智砼兴华智能科技有限公司</h4>
                    <p>地址：北京市大兴区龙发大街1号院3号楼6层3单元618</p>
                    <p>电话：18574931510</p>
                  </div>`,
        offset: new AMap.Pixel(0, -30)
      });
      
      // 点击标记时打开信息窗体
      marker.on('click', () => {
        infoWindow.open(map, marker.getPosition());
      });
      
      // 默认打开信息窗体
      infoWindow.open(map, marker.getPosition());
    },
    // 提交表单
    submitForm() {
      this.$refs.contactForm.validate((valid) => {
        if (valid) {
          this.$message({
            message: '留言提交成功，我们将尽快与您联系！',
            type: 'success'
          });
          // 重置表单
          this.$refs.contactForm.resetFields();
        } else {
          return false;
        }
      });
    }
  }
}
</script>

<style scoped>
/* 页面整体样式 */
.aboutUS {
  background-color: #f9f9fa;
  color: #333;
}

/* 顶部横幅 */
.top {
  position: relative;
  height: 450px;
  overflow: hidden;
}

.top img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.banner-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(to bottom, rgba(0,0,0,0.5), rgba(0,0,0,0.7));
  display: flex;
  align-items: center;
  justify-content: center;
}

.banner-content {
  text-align: center;
  color: white;
  max-width: 800px;
  padding: 0 20px;
}

.banner-content h1 {
  font-size: 48px;
  font-weight: 600;
  margin-bottom: 15px;
  text-shadow: 0 2px 4px rgba(0,0,0,0.3);
  animation: fadeInDown 1s ease;
}

.banner-content p {
  font-size: 18px;
  opacity: 0.9;
  margin: 0;
  text-shadow: 0 1px 2px rgba(0,0,0,0.3);
  animation: fadeInUp 1s ease;
}

/* 容器通用样式 */
.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 公司简介区域 */
.company-intro {
  padding: 60px 0;
  text-align: center;
  background-color: white;
}

.section-title {
  font-size: 32px;
  color: #1890ff;
  margin-bottom: 15px;
  font-weight: 600;
}

.section-divider {
  width: 60px;
  height: 3px;
  background: #1890ff;
  margin: 0 auto 30px;
}

.intro-text {
  max-width: 900px;
  margin: 0 auto;
  font-size: 16px;
  line-height: 1.8;
  color: #666;
}

/* 联系信息区域 */
.contact-section {
  padding: 60px 0;
}

.contact-wrapper {
  display: flex;
  gap: 30px;
}

.contact-info {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 30px;
}

.info-card, .contact-form-card, .map-card {
  background: white;
  border-radius: 8px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.05);
  padding: 30px;
  height: fit-content;
}

.card-title {
  font-size: 20px;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 15px;
  border-bottom: 1px solid #f0f0f0;
}

.info-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.info-list li {
  display: flex;
  margin-bottom: 20px;
  align-items: flex-start;
}

.info-list li:last-child {
  margin-bottom: 0;
}

.info-list i {
  font-size: 24px;
  color: #1890ff;
  margin-right: 15px;
  margin-top: 3px;
}

.info-list h4 {
  font-size: 16px;
  margin: 0 0 5px;
  color: #333;
}

.info-list p {
  margin: 0;
  color: #666;
  line-height: 1.5;
}

/* 地图容器 */
.map-container {
  flex: 1.2;
}

.map-content {
  height: 500px;
  border-radius: 4px;
  overflow: hidden;
}

/* 动画 */
@keyframes fadeInDown {
  from { 
    opacity: 0;
    transform: translateY(-20px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInUp {
  from { 
    opacity: 0;
    transform: translateY(20px);
  }
  to { 
    opacity: 1;
    transform: translateY(0);
  }
}

/* 响应式调整 */
@media (max-width: 992px) {
  .contact-wrapper {
    flex-direction: column;
  }
  
  .banner-content h1 {
    font-size: 36px;
  }
  
  .section-title {
    font-size: 28px;
  }
}

@media (max-width: 768px) {
  .banner-content h1 {
    font-size: 30px;
  }
  
  .company-intro {
    padding: 40px 0;
  }
  
  .contact-section {
    padding: 40px 0;
  }
  
  .map-content {
    height: 350px;
  }
}

/*最上方背景*/
.background {
  background-color: #f5f5f5; /* 浅灰色背景 */
  width: 100%; /* 宽度100% */
  height: 300px; /* 最小高度 */
  padding: 20px; /* 内边距 */
  border-radius: 8px; /* 圆角 */
  box-shadow: 0 2px 10px rgba(0,0,0,0.1); /* 阴影效果 */
}
.background-img {
  position: relative;
  left: 28%;
  top: -20px;
}
.background-text{
  position: relative;
  font-size: 50px;
  font-weight: 700;
  font-family: "Microsoft YaHei";
  left: 43%;
  top: -380px;
}
</style>